$(document).ready(function () {

  var addDays = (date, days = 1) => {
    var result = new Date(date);  
    //console.log('result',result); 
    result.setDate(result.getDate() + days);
    return result;
  };

var dateRange = (start, end, range = []) => {
 // console.log(start+"===="+end);
  if (start > end){ return range; }
  var next = addDays(start, 1);
  var rangVal = dateRange(next, end, [...range, start]);
  return rangVal;
};


var startdate = $('.start-date-main').attr('date');
var enddate = $('.end-date-main').attr("date");
var buffer_date = $('.buffer_date_add').attr("buffer-date");


var range = dateRange(new Date(startdate), new Date(enddate));

  var maindate = range.map((date) => {
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    var yy = date.getFullYear().toString();
    return `${mm}/${dd}/${yy}`;
  });


  
   var unavailableDates = maindate;

    function unavailable(date) {
        dmy = (date.getMonth() + 1) + "/" +date.getDate() + "/" +   date.getFullYear();
        if ($.inArray(dmy, unavailableDates) == -1) {
            return [true, ""];
        } else {
            return [false, "", "Unavailable"];
        }
    }
      
    $(function() {
      
   var daycount = $("input[name='Rental Duration']:checked").val();
      if(daycount == undefined){
        var number = 0;
      } else{
       var number = parseInt(daycount.split(" ")[0]) -1 ;
      }
    datepickerCustom(number)


    });

 $('body').on('click','fieldset.js.product-form__input.variant-input-wrapper[data-option-slug="rental-duration"] label',function () {
        var getText =   $(this).prev('input').val();
      var number = parseInt(getText.split(" ")[0]) -1;
 
     $("#datepicker-delivery").datepicker( "destroy" );
     $("#datepicker-delivery").val(''); 
       datepickerCustom(number)
   
        });

function datepickerCustom(number){
    var startDate = null;
      $("#datepicker-delivery").datepicker({
            dateFormat: 'mm/dd/yy',
            minDate: buffer_date ,
              maxDate: (function() {
                const today = new Date();
                return new Date(today.getFullYear(), today.getMonth() + 6, 0);
            })(),
            beforeShowDay: function(date) {
            if (startDate && date >= startDate && date <= endDate) {
                return [true, 'highlight-range', '']; 
            }
           
            return [true, '', ''];
        },
         onSelect: function(selectedDate) {
            startDate = new Date(selectedDate);
            endDate = new Date(selectedDate);
            endDate.setDate(endDate.getDate() + number);
           if(number == 0){
             $("#datepicker-delivery").val(selectedDate);
           } else{
            $("#datepicker-delivery").val(selectedDate + ' - ' + $.datepicker.formatDate('mm/dd/yy', endDate));
           }
            /* BUGFIX 2026-07-26 — jQuery UI sets .val() directly here, which
               fires NO change event. That is why the old re-enable handler
               (`$("#datepicker-delivery").change(...)`) never ran and the Add
               to Cart button stayed dead after picking a date. Everything that
               reacts to "a date now exists" — the validation message and the
               express-checkout gate — hangs off this event, so fire it. */
            $("#datepicker-delivery").trigger("change");
        }
        
        });
}  

  

  var $cstmval = jQuery(".element-classname").val();

  /* ------------------------------------------------------------------
     Required "preferred arrival date" gate on Add to Cart.

     BUGFIX 2026-07-26 — this used to DISABLE the button when the date was
     empty. A disabled button fires no further click events, so the re-enable
     branch below it could never run. The only other re-enable path was a
     `change` handler on the datepicker, which (a) undid an .attr() with a
     .prop() and (b) depends on jQuery UI actually emitting `change` on select.
     Reproduced on live: tap Add to Cart BEFORE picking a date -> button greys
     out permanently, and picking a date afterwards does NOT recover it. Only a
     full page reload does. Tapping the biggest button first is exactly what a
     scrolling mobile shopper does, and mobile converts at half the desktop
     rate.

     Fix: never disable the button. Block the submit instead, and let the
     shopper retry as soon as they have picked a date. The button cannot get
     stuck because it is never put into a state it can't leave.
     ------------------------------------------------------------------ */
  jQuery(".product-form__submit").on("click", function (e) {
    var empty = false;
    jQuery("#datepicker-delivery").each(function () {
      if (jQuery.trim(jQuery(this).val()) === "") {
        empty = true;
      }
    });

    if (empty) {
      e.preventDefault();
      e.stopImmediatePropagation();          // keep the theme's own submit from running
      jQuery(".validation-message-jtpl").show();
      jQuery("#datepicker-delivery").first().trigger("focus");
      return false;
    }
    jQuery(".validation-message-jtpl").hide();
  });

  /* Clear the warning as soon as a date exists, however it was entered:
     jQuery UI's onSelect, a paste, or typing. Also defensively strips any
     leftover disabled attribute from a pre-fix page state. */
  function glClearDateWarning() {
    if (jQuery.trim(jQuery("#datepicker-delivery").val()) !== "") {
      jQuery(".validation-message-jtpl").hide();
      jQuery(".product-form__submit").removeAttr("disabled").prop("disabled", false);
    }
  }

  /* ------------------------------------------------------------------
     EXPRESS CHECKOUT GATE (2026-07-26)

     Shop Pay / Apple Pay / Google Pay are now enabled on the product
     templates. Those buttons submit the form DIRECTLY — they never fire the
     `.product-form__submit` click handler above, so without this gate an
     express order could be placed with NO arrival date, and the lab would not
     know when to ship a wedding order.

     The gate is CSS-driven (pointer-events + opacity on the wrapper) rather
     than `disabled`, deliberately: the wallet buttons are third-party and
     partly iframed, and a `disabled` attribute is exactly what created the
     stuck-button bug this file just fixed. A CSS gate has no state to get
     stuck in — it re-evaluates from the field's current value every time.
     ------------------------------------------------------------------ */
  function glSyncExpressGate() {
    var $d = jQuery("#datepicker-delivery");
    if (!$d.length) { return; }              // template has no date field -> no gate
    var empty = jQuery.trim($d.val()) === "";
    jQuery(".product-form__buttons").toggleClass("gl-date-required", empty);
  }

  /* One hint line under the wallet buttons, injected once.
     SCOPED to the MAIN buy form (product-form.product-form). Unscoped, this
     also appended to the sticky bar's .product-form__buttons — the sticky bar
     has no wallet buttons to explain, and the extra line bloated it to ~188px
     tall on a 375px screen, eating a quarter of the viewport. */
  jQuery("product-form.product-form .product-form__buttons").each(function () {
    var $b = jQuery(this);
    if (jQuery("#datepicker-delivery").length && !$b.find(".gl-express-hint").length) {
      $b.append('<span class="gl-express-hint">Choose your preferred arrival date above to check out with Shop Pay, Apple Pay or Google Pay.</span>');
    }
  });

  /* ------------------------------------------------------------------
     STICKY-CART DATE CARRY (hotfix 2026-07-26)

     The sticky Add-to-Cart bar renders its OWN /cart/add form. The datepicker
     (#datepicker-delivery, properties[Event Date]) belongs to the main buy
     form only, so the sticky form carried no event date and a shopper who
     picked a date then used the sticky button added a line item WITHOUT it —
     the lab never learned the ship-by date. Silent; it only surfaces weeks
     later as a late delivery.

     The empty-date click gate above already covers the no-date case (the
     sticky button is also .product-form__submit). This is purely about
     carrying the value once a date exists.

     The input itself is now SERVER-RENDERED in sections/main-product.liquid
     (.gl-sticky-event-date, gated on the same metafield as the date field), so
     it exists even if scripts are slow or blocked. This only keeps it in sync.
     ------------------------------------------------------------------ */
  function glSyncStickyDate() {
    jQuery(".gl-sticky-event-date").val(jQuery("#datepicker-delivery").val() || "");
  }

  jQuery("#datepicker-delivery").on("change input blur", function () {
    glClearDateWarning();
    glSyncExpressGate();
    glSyncStickyDate();
  });

  glSyncExpressGate();                        // set the initial state on load
  glSyncStickyDate();

});





